var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "color-drop",
    d: "M194.143,195.9a.152.152,0,0,1,0,.215l-5.86,5.86a1.333,1.333,0,0,1-.949.393h-1.485a1.191,1.191,0,0,0-.847.351,1.032,1.032,0,0,1-1.46-1.46,1.192,1.192,0,0,0,.351-.848v-1.484a1.334,1.334,0,0,1,.393-.949l5.86-5.86a.152.152,0,0,1,.215,0Zm8.021-6.608-3.7,3.7.678.678a.847.847,0,0,1,0,1.2l-1.419,1.419a.848.848,0,0,1-1.2,0l-6.551-6.551a.849.849,0,0,1,0-1.2l1.419-1.419a.847.847,0,0,1,1.2,0l.678.678,3.7-3.7a3.673,3.673,0,1,1,5.195,5.194Z",
    transform: "translate(-183.24 -183.02)",
    fill: "#f8f8f8",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorDropIcon);
export default __webpack_public_path__ + "static/media/color_drop_icon.4cee92c1cd2126c469549eb1039fcc7b.svg";
export { ForwardRef as ReactComponent };